<template>
    <div class="card-block" style="position:relative; top: 75px">
      <h2>Redefinir Senha</h2>
      <p class="text-muted">Digite as informações abaixo para redifinir sua senha!</p>
      <div class="input-group mb-2">
        <span class="input-group-addon"><i class="icon-lock"></i></span>
        <b-form-input type="password"
                id="oldPassword"
                name="oldPassword"
                :placeholder="'Digite sua senha antiga'"
                v-model="oldPassword"
                >
        </b-form-input>
      </div>
      <!-- TODO: THE NEW PASSWORD MUST FOLLOW THE CRITERIA LIST -->
      <div class="input-group mb-2" id="tooltip-target-1">
        <span class="input-group-addon"><i class="icon-lock"></i></span>
        <b-form-input type="password"
                id="newPassword"
                name="newPassword"
                :placeholder="'Digite sua nova senha'"
                v-model="newPassword"
                >
        </b-form-input>
        <b-tooltip variant="light" placement="right" target="tooltip-target-1" triggers="focus">
          <div style="font-size: .75rem; text-align: left;">
            <span style="font-weight: 700;font-size: 1rem;">Requisitos:</span>
            <ul class="mt-2">
              <li :class="newPassword && newPassword.length >= 8 ? 'text-success' : 'text-danger'">
                Comprimento mínimo de 8 caracteres
              </li>
              <li :class="newPassword && /[A-Z]/.test(newPassword) ? 'text-success' : 'text-danger'">
                Letra maiúscula
              </li>
              <li :class="newPassword && /[a-z]/.test(newPassword) ? 'text-success' : 'text-danger'">
                Letra minúscula
              </li>
              <li :class="newPassword && /\d/.test(newPassword) ? 'text-success' : 'text-danger'">
                Número (1 - 9)
              </li>
              <li :class="newPassword && /[!@#$%&*()+-]/.test(newPassword) ? 'text-success' : 'text-danger'">
                Caractere especial (!@#$%&*()+-)
              </li>
            </ul>
          </div>
        </b-tooltip>
      </div>
      <div class="input-group mb-2">
        <span class="input-group-addon"><i class="icon-lock"></i></span>
        <b-form-input type="password"
                id="newPasswordConfirm"
                name="newPasswordConfirm"
                :placeholder="'Confirme a nova senha'"
                v-model="newPasswordConfirm"
                >
        </b-form-input>
      </div>
      <div class="row">
        <div class="col-6 text-left">
          <p  style="color: #04A791" @click="handleBackToLogin" class="btn btn-link px-0"><i class="fa fa-history"></i> Voltar</p>
        </div>
        <div class="col-6 text-right">
          <button type="button" class="btn btn-third px-4" @click="onResetPassword"><i class="fa fa-check-circle"></i> Redefinir</button>
        </div>
      </div>
    </div>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import PasswordRepository from '@/shared/http/repositories/access/password.js'

export default {
  name: 'ChangePassword',
  data () {
    return {
      oldPassword: null,
      newPassword: null,
      newPasswordConfirm: null
    }
  },
  props: {
    expiredPassword: {
      type: Boolean,
      required: false,
      default: false
    },
    username: {
      type: String,
      required: true,
      default: null
    }
  },
  methods: {
    onResetPassword () {
      if (this.username && this.oldPassword && this.newPassword) {
        if (!this.checkPasswords()) return
        const data = {
          // TODO: ARE THE PASSWORD NAMES FOR BODY ACCORDING TO BACK END EXPECTS?
          'userName': this.username,
          'currentPassword': this.oldPassword,
          'newPassword': this.newPassword
        }

        PasswordRepository.SetPassword(data)
          .then((response) => {
            if (response.status === 200) {
              toast.success('Senha redefinida com sucesso!')
              this.loginAndRedirect()
            } else {
              toast.error('Não foi possível alterar a senha')
            }
          })
          .catch((err) => {
            if (err.data.errors[0].message) {
              toast.warning(err.data.errors[0].message, 'Atenção!')
            } else {
              console.error(err)
            }
          })
      } else {
        toast.warning('ATENÇÃO! Todos os campos são obrigatórios.')
      }
    },
    checkPasswords () {
      const password = this.newPassword
      const confirmation = this.newPasswordConfirm

      if (!password) {
        return
      }

      const minLength = 8
      const hasUppercase = /[A-Z]/.test(password)
      const hasLowercase = /[a-z]/.test(password)
      const hasNumber = /\d/.test(password)
      const hasSpecialChar = /[!@#$%&*()+-]/.test(password)

      const isLengthValid = password.length >= minLength
      const isAllConditionsMet = hasUppercase && hasLowercase && hasNumber && hasSpecialChar

      if (!isLengthValid) {
        this.showError('A senha deve conter no mínimo 8 caracteres')
      } else if (!isAllConditionsMet) {
        this.showError('A senha precisa ter no mínimo um caractere de cada: letra maiúscula, letra minúscula, número e caractere especial')
      } else if (confirmation && password !== confirmation) {
        this.showError('A senha e sua confirmação não são iguais. Verifique e informe novamente, por favor')
      } else {
        return true
      }
      return false
    },
    loginAndRedirect () {
      this.$emit('login', this.username, this.newPassword)
    },
    showError (message) {
      toast.warning(`ATENÇÃO! ${message}`)
    },
    handleBackToLogin () {
      this.$emit('BackToLogin')
    },
    checkPasswordsMatch () {
      return this.newPassword === this.newPasswordConfirm
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/auth/change/ChangePassword.vue